module.exports = __webpack_public_path__ + "img/homerooom-thumbnail.1cc10540.png";